import { render } from "./DesexingMicrochipping.vue?vue&type=template&id=c41122ca&scoped=true"
import script from "./DesexingMicrochipping.vue?vue&type=script&lang=js"
export * from "./DesexingMicrochipping.vue?vue&type=script&lang=js"

import "./DesexingMicrochipping.vue?vue&type=style&index=0&id=c41122ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c41122ca"]])

export default __exports__